import { useState } from 'react'

import { Flex } from '@react-css/flex'
import mixpanel from 'mixpanel-browser'

import { useUserContext } from '../../../../contexts/userContext'

import { ChatMenu } from './ChatMenu'
import { ChatInputForm, InputContainer, ChatInputField } from './styles'

interface ChatInputProps {
  viewerId: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper sendMessage type
  sendMessage: any
}

export const ChatInput = ({ sendMessage, viewerId }: ChatInputProps) => {
  const userState = useUserContext().state
  const [chatInput, setChatInput] = useState<string>('')

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: Replace with proper event type
  const onPressEnter = (e: any) => {
    e.preventDefault()
    if (chatInput !== '') {
      const messageData = {
        sender: userState.public_id,
        content_type: 'TEXT',
        content: chatInput,
        event_type: 'chat_message',
      }
      sendMessage(JSON.stringify(messageData))
      setChatInput('')
      mixpanel.track('Send Chat')
    }
  }

  return (
    <InputContainer>
      <Flex flexDirection="row">
        <ChatInputForm onSubmit={onPressEnter}>
          <ChatInputField
            type="text"
            id="chat-input"
            placeholder="Type a message..."
            onChange={e => {
              setChatInput(e.target.value)
            }}
            value={chatInput}
          />
        </ChatInputForm>
        <Flex
          flexDirection="row"
          style={{
            alignItems: 'center',
            width: '5%',
            justifyContent: 'space-evenly',
          }}
        >
          <ChatMenu viewerId={viewerId} />
        </Flex>
      </Flex>
    </InputContainer>
  )
}
